import { Toast } from 'vant'
import store from '@/store'

export const ErrorType = {
  NETWORK: 'NETWORK',
  SERVER: 'SERVER',
  CLIENT: 'CLIENT',
  AUTH: 'AUTH'
}

const ErrorCodeMap = {
  400: '请求参数错误',
  401: '登录已过期，请重新登录',
  403: '没有权限访问',
  404: '请求的资源不存在',
  500: '服务器内部错误，请稍后重试',
  502: '网关错误',
  503: '服务不可用',
  504: '网关超时'
}

class ErrorHandler {
  handleApiError(error, options = {}) {
    const { showToast = true, logError = true } = options

    if (logError) {
      this.logError(error)
    }

    const errorInfo = this.parseError(error)

    if (showToast) {
      this.showErrorToast(errorInfo)
    }

    return errorInfo
  }

  parseError(error) {
    if (!error.response) {
      if (error.request) {
        return {
          type: ErrorType.NETWORK,
          message: '网络连接失败，请检查网络设置',
          code: null
        }
      }
      return {
        type: ErrorType.CLIENT,
        message: error.message || '请求配置错误',
        code: null
      }
    }

    const { status, data } = error.response

    if (status === 401 || status === 403) {
      return {
        type: ErrorType.AUTH,
        message: ErrorCodeMap[status] || '认证失败',
        code: status
      }
    }

    if (status >= 500) {
      return {
        type: ErrorType.SERVER,
        message: ErrorCodeMap[status] || '服务器错误',
        code: status
      }
    }

    return {
      type: ErrorType.CLIENT,
      message: data?.message || ErrorCodeMap[status] || '请求失败',
      code: status
    }
  }

  showErrorToast(errorInfo) {
    Toast({
      message: errorInfo.message,
      position: 'top',
      duration: 3000,
      type: 'fail'
    })
  }

  logError(error) {
    console.error('API Error:', {
      message: error.message,
      stack: error.stack,
      response: error.response?.data,
      request: error.request
    })
  }

  handleAuthError() {
    localStorage.removeItem('user')
    localStorage.removeItem('token')
    store.dispatch('logout')
    window.location.href = '/login'
  }

  showError(message, options = {}) {
    Toast({
      message,
      position: 'top',
      duration: 3000,
      type: 'fail',
      ...options
    })
  }

  showSuccess(message, options = {}) {
    Toast({
      message,
      position: 'top',
      duration: 2000,
      type: 'success',
      ...options
    })
  }
}

export default new ErrorHandler()
